import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import CreateAdmissionComp  from "./Component/CreateAdmissionComp"

const CreateAdmission =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <CreateAdmissionComp />
        </div>
        <Footer />
        </>
    )
}

export default CreateAdmission